import { Component, ViewChild, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'lowy-clear-search',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Reset Parameters</div>
      <div class="subheading">This will remove all parameters that have been selected.</div>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="clearSearch()">clear</span>
      </div>
    </div>
  </lowy-modal>
  `
})
export class ClearSearchComponent {

  @ViewChild('modal') modal: ModalComponent;

  public clearSearchEventEmitter: Subject<boolean>;

  constructor() {
    this.clearSearchEventEmitter = new Subject();
  }

  public open() {
    this.modal.open();
  }

  clearSearch() {
    this.clearSearchEventEmitter.next();
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/clear-search-modal.component.ts